<template>
  <div class="container pl-4">
    <div id="device-status">
      <MetricsHeader :title="$t('dashboard.metrics.device_status')" :timespan="$t('dashboard.metrics.timespan.now')" />
      <VueApexCharts type="donut" :options="chartOptions" :series="series" />
    </div>
  </div>
</template>

<script setup lang="ts">
import VueApexCharts from 'vue-apexcharts';
import { IDeviceStatusItem } from '@/store/modules/metrics/types';
import Metrics from '@/mixins/Metrics';
import useStore from '@/utils/store/common';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import MetricsHeader from './components/MetricsHeader.vue';

const store = useStore();

const chartOptions = ref({});
const series = ref([] as number[]);

const { t } = useI18n();

onMounted(async () => {
  const metrics: IDeviceStatusItem[] = await store.dispatch('metrics/fetchDeviceStatus');
  const deviceStatus = Metrics.transformDeviceStatusData(metrics);
  deviceStatus.labels.forEach((label, i) => { deviceStatus.labels[i] = t(label).toString(); });
  chartOptions.value = Metrics.getPieChartOptions(deviceStatus);
  series.value = deviceStatus.series;
});
</script>
<style lang="scss" scoped>
@import './styles/device-status.scss';
</style>
